module.exports = __webpack_public_path__ + "img/prizes-zone.6cf04dea.jpg";